import { getBadgeModel } from '~/router/navigation/badges';
import { ROUTES_BADGES_TYPES } from '~/router/routes';

import { HUB_TILES } from './clanHub.tiles.config';

import type { HUB_TILE, HubTileConfig } from './clanHub.tiles.config';
import type { BadgeModel } from '~/router/navigation/types';
import type { NavigationContext } from '~/store/selectors/navigationSelectors';

export type HubTileModel = HubTileConfig & {
  enabled: boolean;
  visible: boolean;
  toResolved?: string;
  endsAtResolved?: number | null;
  endsAtTextLabelResolved?: string | null;
  warningBadgeResolved?: string | null;
  badgesResolved?: BadgeModel[];
};

export function buildHubTiles(tiles: HUB_TILE[], navigationContext: NavigationContext): HubTileModel[] {
  return tiles
    .map((tileId) => {
      const tile = HUB_TILES[tileId];

      const visible = tile.isVisible?.(navigationContext) ?? true;
      const enabled = tile.isEnabled?.(navigationContext) ?? true;

      const toResolved = typeof tile.to === 'function' ? tile.to(navigationContext) : tile.to;

      const endsAtResolved = tile.endsAt?.(navigationContext);
      const endsAtTextLabelResolved = tile.endsAtTextLabel?.(navigationContext);

      const warningBadgeResolved = tile.warningBadge?.(navigationContext) ?? null;
      const badgesResolved = tile.badges
        ?.map((badge) => {
          return getBadgeModel(badge, navigationContext);
        })
        .filter((badgeResolved) => {
          if (!badgeResolved || badgeResolved.kind === ROUTES_BADGES_TYPES.NONE) {
            return false;
          }
          return true;
        });

      return {
        ...tile,
        visible,
        enabled,
        toResolved,
        badgesResolved,
        endsAtResolved,
        endsAtTextLabelResolved,
        warningBadgeResolved,
      };
    })
    .filter((tile) => tile.visible);
}
